import axios from 'axios'
import {urlServices} from '../helper/urlsBase'


export const httpClient = axios.create({
    baseURL:urlServices.URL_SERVICE_TIENDA
}) 